module.exports = __webpack_public_path__ + "static/image/company/pc/image_value@3x.jpg?5d22e6bd";